<template>
  <div id="products" class="main">
    <Hero backimg="background-image:url(/images/hero-products.jpg)"
      :title="$t('products.banner')"
      sub="Fresh Life Starts From Today" />

    <div class="color-change">
      <div class="text-center">
        <div class="base-title ft-30">{{ title }}</div>
        <div class="base-sub ff-dr ft-14">
          {{ sub }}
        </div>
      </div>

      <div class="wrap-1500">
        <div class="btn-wrap">
          <Morebtn :dark="true"
            :text="$t('Morebtn2')"
            @btn-click="gotoFatherPage" />
        </div>
      </div>

      <div class="wrap-1500">
        <div class="productlist">
          <div class="productitem"
            v-for="item in items"
            :key="item.ID">
            <ProductItem
              :id="item.ID"
              :img="item.SMALLPIC | imgFilter"
              :title="item.PRONAME"
              :info="item.MS"
              @select-product="gotoProductPage" />
          </div>
        </div>

        <div class="btn-wrap center" :class="{ hasMore }">
          <Morebtn :dark="true"
            :text="$t('Morebtn1')"
            @btn-click="showMore" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import Morebtn from '@/components/Morebtn.vue'
import ProductItem from '@/components/ProductItem.vue'
import { getProducttypeUrl, getProductsUrl } from '@/util/url.js'
import axios from 'axios'

// const mockData = [
//   {
//     ID: '0',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '1',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '2',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '3',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '4',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '5',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '6',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '7',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '8',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   },
//   {
//     ID: '9',
//     img: '/images/randonnee-a-landmannalaugar-1271.png',
//     title: '金枪鱼罐头',
//     info: '明星产品,健康绿色,富含DHA、EPA、Omega-3,富含Omega-3、Ca,富含维他命,富含多元不饱和脂肪酸。'
//   }
// ]

export default {
  components: {
    Hero,
    Morebtn,
    ProductItem
  },

  data () {
    return {
      title: '',
      sub: '',
      hasMore: false,
      items: []
    }
  },

  watch: {
    '$route': 'fetchView'
  },

  mounted () {
    document.title = `${this.$t('nav.products')}-${this.$t('title')}`
    this.fetchView()
  },

  // mounted () {
  //   this.fechData()

  //   this.$nextTick(() => {
  //     if (window.scrollBar) window.scrollBar.scrollTop = 0

  //     setTimeout(() => {
  //       this.loader.hide()
  //     }, 300)
  //   })

  //   this.count = 8
  //   this.step = 8
  //   this.hasMore = false
  // },

  methods: {
    fetchView () {
      this.count = 8
      this.step = 8
      this.hasMore = false

      this.$nextTick(() => {
        if (window.scrollBar) window.scrollBar.scrollTop = 0

        // setTimeout(() => {
        //   this.loader.hide()
        // }, 300)
      })

      this.fechData()
    },

    gotoFatherPage () {
      this.$router.push({ name: 'productgroups' })
    },

    gotoProductPage (id) {
      const fid = this.$route.params.id
      let routeUrl = this.$router.resolve(`/product/${fid}/${id}`)
      window.open(routeUrl.href, '_blank')
    },

    fechData () {
      const id = this.$route.params.id
      const url0 = getProducttypeUrl(id)
      axios.get(url0).then(res => {
        // console.log(res)
        if (res && res.data) {
          this.title = res.data.CALLED
          this.sub = res.data.EN
        }
      })

      const url = getProductsUrl(this.$store.state.lang, id)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.data = res.data.proarr
          this.filterData()
        }
      })
    },

    filterData () {
      this.items = this.data.slice(0, this.count)
      this.count += this.step

      // console.log(this.data.length, this.items.length)
      if (this.data.length > this.items.length) this.hasMore = true
      else this.hasMore = false
    },

    showMore () {
      this.filterData()
    }
  }
}
</script>

<style lang="scss" scoped>
.main, .color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}

.text-center {
  text-align: center;
  padding: 100px 30px 30px 30px;
}
.base-title {
  line-height: 60px;
  color: #09192a
}
.base-sub {
  line-height: 32px;
  color: #82a6be;
}

.wrap-1500 {
  max-width: 1500px;
  width: 100%;
  margin: 0 auto;
}

.btn-wrap {
  display: flex;
  justify-content: flex-end;
}
.btn-wrap.center {
  display: none;
  justify-content: center;
}
.hasMore.btn-wrap.center {
  display: flex;
}

.productlist {
  padding: 30px 0;
  display: flex;
  flex-wrap: wrap;
}
.productitem {
  width: 25%;
  padding: 32px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media(max-width: 768px){
  .productitem{
    width: 50%;
  }
}
</style>
